(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.expressionOfGratitudeEntityKey = void 0;

  /**
   * Entity key used by the expressionOfGratitude schema
   * @type {string}
   */
  var expressionOfGratitudeEntityKey = "expressionOfGratitude";
  _exports.expressionOfGratitudeEntityKey = expressionOfGratitudeEntityKey;
});